import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiLogIn } from 'react-icons/fi';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError(
        err.response?.data?.message ||
        err.response?.data?.error ||
        'שגיאה בהתחברות. אנא בדוק את הפרטים ונסה שנית.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-watermark"><img src="/logo192.png" alt="" /></div>
      <div className="auth-card">
        <div className="auth-logo-mark">
          <img src="/logo192.png" alt="מחשבון מעשר" />
        </div>

        <h1 className="auth-title">התחברות למערכת</h1>
        <p className="auth-subtitle">מחשבון מעשר — ניהול הכנסות, הוצאות ומעשרות</p>

        {error && <div className="alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">שם משתמש / אימייל</label>
            <input
              id="username"
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="הזן שם משתמש או אימייל"
              required
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">סיסמה</label>
            <input
              id="password"
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="הזן סיסמה"
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', padding: '14px', fontSize: '0.95rem' }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="loading-spinner" style={{ width: 18, height: 18, borderWidth: 2, borderTopColor: '#fff' }} />
                מתחבר...
              </>
            ) : (
              <>
                <FiLogIn />
                התחברות
              </>
            )}
          </button>
        </form>

        <div className="auth-toggle">
          אין לך חשבון? <Link to="/register">הירשם כאן</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
